import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/crm/expense/claim";

/**
 * 费用报销页接口
 *
 * 保存拆成两个：saveDraft 存草稿（状态由服务端强制置 0），
 * saveSubmit 保存并提交（状态置 100 并发起工作流）。
 */
export default {
    /** 查询报销单列表 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data}),
    /** 申请一个编码，用作新增报销单的 id（工作流拦截器要用它做 biz_key） */
    applyCode: () => axios.get({url: `${PREFIX_URI}/applyCode`}),
    /** 查询报销单详情 */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id}}),
    /** 保存草稿 */
    saveDraft: (data) => axios.post({url: `${PREFIX_URI}/saveDraft`, data}),
    /** 保存并提交审批 */
    saveSubmit: (data) => axios.post({url: `${PREFIX_URI}/saveSubmit`, data}),
    /** 撤回 */
    withdrawClaim: (id) => axios.post({url: `${PREFIX_URI}/withdrawClaim`, data: {id}}),
    /** 删除 */
    delete: (id) => axios.del({url: `${PREFIX_URI}/delete`, data: {id}}),
    /** 报销页的 KPI 与费用类型分布 */
    stat: (data) => axios.get({url: `${PREFIX_URI}/stat`, data}),
    /**
     * 查询本单据的审批流转记录（列表「查看审批」用）。
     * 业务类型由服务端写死为 ExpenseClaim，前端只传单据 id。
     */
    queryFlowInstance: (id) => axios.get({url: `${PREFIX_URI}/queryFlowInstance`, data: {id}}),
}
